// extracted by mini-css-extract-plugin
module.exports = {"cls1":"layout-Content-module--cls1--UTp-s","cls2":"layout-Content-module--cls2--28gGh layout-Content-module--cls1--UTp-s"};